<template>
  <ul class="pagination" :class="paginationClass">
<!--    <li-->
<!--      class="page-item prev-page"-->
<!--      :class="{ disabled: value === 1, 'no-arrows': noArrows }"-->
<!--    >-->
<!--      <a class="page-link" aria-label="Previous" @click="prevPage">-->
<!--        <i class="fas fa-angle-left"></i>-->
<!--      </a>-->
<!--    </li>-->
    <li
      class="page-item"
      v-for="item in previousWeeksRange"
      :key="item.weekNumber"
      :class="{ active: value === item.weekNumber && !retoucherView }"
    >
      <a class="page-link" @click="changePage(item.weekNumber, item.year)">{{ item.weekNumber }}</a>
    </li>

<!--    <li-->
<!--        class="page-item"-->

<!--        :key="maxPage + '+1'"-->
<!--        :class="{ active: value === previousWeeksRange[previousWeeksRange.length-1].weekNumber && retoucherView }"-->
<!--    >-->
<!--      <a class="page-link tm-page-link-current" @click="changePage( previousWeeksRange[previousWeeksRange.length-1].weekNumber, previousWeeksRange[previousWeeksRange.length-1].year,true)">-->
<!--&lt;!&ndash;        {{previousWeeksRange[previousWeeksRange.length-1].weekNumber }}+1&ndash;&gt;-->
<!--        {{ local_page_keys.pagination_link_current }}-->
<!--      </a>-->
<!--    </li>-->
<!--    <li-->
<!--      class="page-item page-pre next-page"-->
<!--      :class="{ disabled: value === totalPages, 'no-arrows': noArrows }"-->
<!--    >-->
<!--      <a class="page-link" aria-label="Next" @click="nextPage">-->
<!--        <i class="fas fa-angle-right"></i>-->
<!--      </a>-->
<!--    </li>-->
  </ul>
</template>
<script>
export default {
  name: "PaginationRetoucher",
  props: {
    type: {
      type: String,
      default: "primary",
      validator: value => {
        return [
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
          "rose"
        ].includes(value);
      }
    },
    noArrows: Boolean,
    pageCount: {
      type: Number,
      default: 0
    },
    week: {
      type: Number,
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    },
    local_page_keys: {
      type: Object,
    }
  },
  computed: {
    paginationClass() {
      //return `pagination-${this.type}`;
      return `pagination-success`;
    },
    totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    },
    previousWeeksRange(){
      //return this.getPreviousWeeks(this.weeksRange);
      return this.getWeekRanges(this.weeksRange);
    }
  },
  data() {
    return {
      defaultPagesToDisplay: 13,
      retoucherView: false,
      weeksRange: 7,
    };
  },
  methods: {

    getWeekRange(weekNumber, year) {
      const startDate = new Date(year, 0, 1);
      const startWeekFirstDay = new Date(startDate.getTime());
      startWeekFirstDay.setDate(startDate.getDate() + (weekNumber - 1) * 7);

      const endDate = new Date(year, 0, 1);
      const endWeekLastDay = new Date(endDate.getTime());
      endWeekLastDay.setDate(endDate.getDate() + (weekNumber - 1) * 7 + 6);

      return [startWeekFirstDay, endWeekLastDay];
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      // Calculate full weeks to nearest Thursday
      const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      // Return array of year and week number
      //return [ weekNo, d.getUTCFullYear()];
      return { year: d.getUTCFullYear(), weekNumber: weekNo };
    },
    getWeekRanges(count) {
      const currentDate = new Date();
      let weekRanges = [];

      // Next week (1 week forward)
      let nextWeekDate = new Date(currentDate.getTime());
      nextWeekDate.setDate(currentDate.getDate() + 7);
      weekRanges.unshift(this.getWeekNumber(nextWeekDate));

      // Current week
      weekRanges.unshift(this.getWeekNumber(currentDate));

      // Previous 6 weeks (6 weeks backward)
      for (let i = 1; i <= count; i++) {
        let pastWeekDate = new Date(currentDate.getTime());
        pastWeekDate.setDate(currentDate.getDate() - 7 * i);
        weekRanges.unshift(this.getWeekNumber(pastWeekDate));
      }
      return weekRanges;
    },
    getCurrentWeek() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentWeek = this.getISOWeek(now);
      return [currentWeek, currentYear];
    },
    getISOWeek(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const dayOfYear = Math.floor((date - firstDayOfYear) / (24 * 60 * 60 * 1000));
      const weekNumber = Math.ceil((date.getDay() + 1 + dayOfYear) / 7);
      return weekNumber;
    },
    getPreviousWeeks(count) {
      const currentWeekInfo = this.getCurrentWeek();
      let weeks = [];

      for (let i = 0; i < count; i++) {
        const [weekNumber, year] = currentWeekInfo;
        weeks.unshift({ weekNumber, year });

        if (weekNumber === 1) {
          currentWeekInfo[0] = 52;
          currentWeekInfo[1] = year - 1;
        } else {
          currentWeekInfo[0] = weekNumber - 1;
        }
      }

      return weeks;
    },

    changePage(week, year, retoucherView = false) {
      //console.log(item, retoucherView);
      if(retoucherView){
        this.retoucherView = true;
      } else {
        this.retoucherView = false;
      }
      this.$emit("input-child", {page:week, year: year, retoucherView: retoucherView});
      //this.$emit("retoucherView", retoucherView);
    },
    nextPage() {
      if (this.value < this.totalPages) {
        this.$emit("input", this.value + 1);
      }
    },
    prevPage() {
      if (this.value > 1) {
        this.$emit("input", this.value - 1);
      }
    }
  },
  watch: {
    perPage() {
      this.$emit("input", 1);
    },
    total() {
      this.$emit("input", 1);
    }
  }
};
</script>
